export default __webpack_public_path__ + "static/media/upangle_icon.0311f2ce.svg";